import React, { ReactNode } from 'react';
import { Check } from 'lucide-react';

interface CheckItemProps {
  title: string;
  description: string | ReactNode;
}

export const CheckItem: React.FC<CheckItemProps> = ({ title, description }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-6 h-6 mt-0.5 rounded-full bg-orange-500 flex items-center justify-center">
          <Check className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">{title}</h3>
      </div>
      <div className="ml-9">
        {typeof description === 'string' ? (
          <p className="text-gray-700">{description}</p>
        ) : (
          description
        )}
      </div>
    </div>
  );
}; 